import * as React from "react";
import { useState } from "react";
import TabsGroup from "../commons/components/tabs/TabsGroup";

interface SettingsCustomizationPanelProps {
  title: string;
  mainTitle?: boolean;
  introduction?: string;
  children?: React.ReactNode;
  actionButton?: {
    title: string;
    action: () => void;
  };
  tabs?: string[];
}

const SettingsCustomizationPanel = (props: SettingsCustomizationPanelProps) => {
  const { introduction, children } = props;
  const [currentTab, setCurrentTab] = useState(0);
  const childArray = React.Children.toArray(children);
  return (
    <div className="setting-description full-col">
      <div className="header-section h-flex space-between">
        <div className="full-col">
          <div className={`setting-title ${props.mainTitle ? "is-main-title" : ""}`}>
            <span>{props.title}</span>
          </div>
          {introduction && (
            <div className="introduction-section">
              <p className="introduction">{introduction}</p>
            </div>
          )}
        </div>
        {props.actionButton && (
          <button className="button-primary filled right" onClick={props.actionButton.action}>
            {props.actionButton.title}
          </button>
        )}
      </div>
      <hr className="no-margin" />
      {props.tabs && props.tabs.length > 1 && (
        <TabsGroup tabs={props.tabs} contentArray={childArray} />
      )}
      {(!props.tabs || props.tabs.length === 1) && <div className="tab-content">{children}</div>}
    </div>
  );
};

export default SettingsCustomizationPanel;
